import React from "react";
import SectionTitle from "../components/SectionTitle";
import Card from "../components/Card";

const cardBody = [
  {
    title: "Mission",
    description: [
      "To provide high quality and informative reports to clients, produce superior returns for shareholders, offer rewarding opportunities for employees, and to increase revenue for new and existing customers.",
    ],
  },
  {
    title: "Vision",
    description: [
      "To stay ahead of the competition and to be the most preferred and trusted business information provider in the Philippines.",
    ],
  },
  {
    title: "Location",
    description: [
      "We are located at: Unit 1407 14/F, Jollibee Plaza Bldg, Emerald Avenue Ortigas Center, Pasig City",
    ],
  },
];

export default function About() {
  return (
    <div className="d-flex w-100 align-items-center flex-column pt-4 pb-5 ps-3 pe-3 gap-3">
      <div className="text-center pb-4">
        <SectionTitle title="About Us" />
        <div className="d-flex justify-content-center rounded bg-light pt-2 pb-2">
          <p className="text-center w-75 p-0 m-0 text-secondary fw-medium">
            “Our Business is founded on One Vital Value: INTEGRITY”
          </p>
        </div>
      </div>
      <Card
        image="/assets/building.png"
        body={cardBody}
        fitImage
        reverseOnBreakpoint
        imageHeight="25rem"
      />
    </div>
  );
}
